<script lang="ts">
  // Partage d'un résultat : lien de la page, image PNG (aperçu, lien, copie, téléchargement).
  let { shareId }: { shareId: string } = $props();
  const pageURL = $derived(`${location.origin}/r/${shareId}`);
  const imageURL = $derived(`${location.origin}/v1/results/${shareId}/image.png`);
  let done = $state('');
  let loaded = $state(false);

  function flash(msg: string) {
    done = msg;
    setTimeout(() => (done = ''), 2200);
  }
  async function copyText(text: string, msg: string) {
    try {
      await navigator.clipboard.writeText(text);
      flash(msg);
    } catch {
      prompt('Copiez ce lien :', text);
    }
  }
  async function copyImage() {
    try {
      // La promesse est passée directement à ClipboardItem (exigé par Safari).
      const blob = fetch(imageURL).then((r) => r.blob());
      await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
      flash('Image copiée');
    } catch {
      flash('Copie de l’image impossible dans ce navigateur : utilisez « Télécharger »');
    }
  }
  async function nativeShare() {
    try {
      const file = new File([await (await fetch(imageURL)).blob()], 'mesurio.png', { type: 'image/png' });
      const data: { title: string; url: string; files?: File[] } = { title: 'Mon test Mesurio', url: pageURL };
      if (navigator.canShare?.({ files: [file] })) data.files = [file];
      await navigator.share(data);
    } catch {
      /* partage annulé */
    }
  }
</script>

<section class="card share" aria-labelledby="titre-partage-{shareId}">
  <h2 id="titre-partage-{shareId}">Partager</h2>
  <div class="layout">
    <a class="preview" class:loaded href={imageURL} target="_blank" rel="noopener" aria-label="Ouvrir l’image du résultat">
      <img src={imageURL} alt="Résultat : débits, latence et réactivité" width="1200" height="630" loading="lazy" onload={() => (loaded = true)} />
    </a>
    <div class="side">
      <label for="lien-page-{shareId}">Lien de la page</label>
      <div class="field">
        <input id="lien-page-{shareId}" readonly value={pageURL} aria-label="Lien de partage" onfocus={(e) => (e.target as HTMLInputElement).select()} />
        <button onclick={() => copyText(pageURL, 'Lien de la page copié')}>Copier</button>
      </div>
      <label for="lien-image-{shareId}">Lien de l’image (PNG)</label>
      <div class="field">
        <input id="lien-image-{shareId}" readonly value={imageURL} onfocus={(e) => (e.target as HTMLInputElement).select()} />
        <button onclick={() => copyText(imageURL, 'Lien de l’image copié')}>Copier</button>
      </div>
      <div class="actions">
        <button class="primary" onclick={copyImage}>Copier l’image</button>
        <a class="button" href={imageURL} download="mesurio-{shareId}.png">Télécharger le PNG</a>
        {#if 'share' in navigator}<button onclick={nativeShare}>Partager…</button>{/if}
      </div>
      <p class="small muted">Collé dans une messagerie ou un réseau social, le lien de la page s’affiche avec cette image en aperçu.</p>
      <p class="status" role="status" aria-live="polite">{done}</p>
    </div>
  </div>
</section>

<style>
  .layout { display: grid; grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr); gap: 20px; align-items: start; }
  @media (max-width: 760px) { .layout { grid-template-columns: 1fr; } }
  .preview { display: block; border-radius: 12px; overflow: hidden; border: 1px solid var(--border); background: var(--surface-2); aspect-ratio: 1200 / 630; }
  .preview img { width: 100%; height: 100%; display: block; object-fit: cover; opacity: 0; transform: scale(1.02); transition: opacity 0.4s ease, transform 0.6s ease; }
  .preview.loaded img { opacity: 1; transform: none; }
  .preview:hover img { transform: scale(1.015); }
  label { margin-top: 0; }
  .field { display: flex; gap: 8px; margin-bottom: 12px; }
  .field input { flex: 1; min-width: 0; font-size: 0.92rem; }
  .actions { display: flex; flex-wrap: wrap; gap: 8px; }
  .status { min-height: 1.4em; color: var(--ok); font-weight: 600; margin: 0.4rem 0 0; }
</style>
